import { render, staticRenderFns } from "./PremiumPlusModal.vue?vue&type=template&id=c80c1b36&scoped=true&"
import script from "./PremiumPlusModal.vue?vue&type=script&lang=js&"
export * from "./PremiumPlusModal.vue?vue&type=script&lang=js&"
import style0 from "./PremiumPlusModal.vue?vue&type=style&index=0&id=c80c1b36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80c1b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80c1b36')) {
      api.createRecord('c80c1b36', component.options)
    } else {
      api.reload('c80c1b36', component.options)
    }
    module.hot.accept("./PremiumPlusModal.vue?vue&type=template&id=c80c1b36&scoped=true&", function () {
      api.rerender('c80c1b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/PremiumPlusModal.vue"
export default component.exports